module.exports = __webpack_public_path__ + "img/TOPAS_img_3.2564606f.png";